export default __webpack_public_path__ + "static/media/upload.d5737cc0.png";